import { render } from "./PopUpMsg.vue?vue&type=template&id=83ea7a76"
import script from "./PopUpMsg.vue?vue&type=script&lang=js"
export * from "./PopUpMsg.vue?vue&type=script&lang=js"

import "./PopUpMsg.vue?vue&type=style&index=0&id=83ea7a76&lang=css"

import exportComponent from "F:\\Development\\#Personal\\17 - Plásticos\\GIT\\ManagerBusinessAPP\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__